import React from 'react';
import PropTypes from 'prop-types';
import map from 'lodash/map';
import { driveTypeLabel, DE_MANFACTURARER, NDE_MANFACTURARER } from './constants';
import Tippy from '@tippy.js/react';
import { translate } from 'helpers/translateHelper';
import { IconWarningType } from 'svgIcons/MotionPortalIcons';
import { InfoButtonWithOnlineHelp } from 'sharedComponents/InfoButtonWithOnlineHelp';
import { assetStatus } from '../../../PowertrainFleets/FleetsDashboard/constants';

const isUnknownBearingMake = (assetDetail) => (assetDetail?.label === NDE_MANFACTURARER || assetDetail?.label === DE_MANFACTURARER) && assetDetail?.value === assetStatus.UNKNOWN;

const renderDriveTypeValue = (assetDetail) => {
	return <div id='drive-type-warning' className='drive-type-values'>
		<Tippy
			content={translate('ABB.Powertrain.Frontend.driveTypeWarningMessage')}
			interactive={true}
			interactiveBorder={10}
			animation='scale'
			theme='light-border'
			trigger='click'
			placement='top'
			maxWidth={300}
		>
			<div id='drive-type-warning-icon' className='warning-icon'>
				<IconWarningType />
			</div>
		</Tippy>
		<div id='drive-type-warning-value'>{assetDetail?.value ?? '-'}</div>
	</div>;
};

const renderBearingMakeValue = (assetDetail) => {
	return <div id='bearing-make-info' className='bearing-make-values'>
		<div id='bearing-make-value'>{assetDetail?.value ?? '-'}</div>
		<InfoButtonWithOnlineHelp
			infoText={translate('ABB.Powertrain.Frontend.bearingMakeInfoMessage')}
			trigger='click'
			placement='top'
			withoutLink
			width='16'
		/>
	</div>;
};

const renderAssetDetailValue = (assetDetail, isDriveTypeChanged) => {
	if (assetDetail.label === driveTypeLabel && isDriveTypeChanged) {
		return renderDriveTypeValue(assetDetail);
	}
	if (isUnknownBearingMake(assetDetail)) {
		return renderBearingMakeValue(assetDetail);
	}
	return assetDetail?.value ?? '-';
};

const AssetDetailsList = ({ title, data, isDriveTypeChanged }) => {
	return <div className={'asset-detail-list-container'}>
		{data ? <div className='asset-detail-list'>
			<div className='asset-detail-list-title'>{title}</div>
			{map(data, (assetDetail) => {
				return <div className='asset-detail-list-item' key={assetDetail?.label}>
					<div className='data-label'>{assetDetail?.label}</div>
					<pre className='data-value'>
						{renderAssetDetailValue(assetDetail, isDriveTypeChanged)}
					</pre>
				</div>;
			})}
		</div> : null}
	</div>;
};

export default AssetDetailsList;

AssetDetailsList.propTypes = {
	title: PropTypes.string,
	data: PropTypes.arrayOf(PropTypes.shape({
		label: PropTypes.string,
		value: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.node]),
	})),
	isDriveTypeChanged: PropTypes.bool,
};
